var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlleys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "59px",
    viewBox: "0 0 52 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.18018102 32,16.0373832 C32,20.8685844 29.8687274,25.2008371 26.4971752,28.1410666 L16.0250448,39 L5.52692836,28.1620446 C2.1414336,25.221464 0,20.8800872 0,16.0373832 C0,7.18018102 7.163444,0 16,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.8511108,14.9154562 L14.5249374,13.0140751 L14.6767283,12.7104932 C15.7312758,11.1766059 15.6833419,8.89974194 14.5728714,7.29395367 C14.5489044,7.26199769 14.5329264,7.2300417 14.5169484,7.20607472 C13.3425659,5.60827545 11.3612948,5.15290266 9.73952856,6.01571425 C9.55578164,6.1115822 9.37203473,6.22342816 9.2042658,6.35924109 C9.14035383,6.39918608 9.08443084,6.45510905 9.02051889,6.50304303 C8.64503606,6.82260289 8.31748722,7.2140637 8.06183933,7.6614475 C7.95798238,7.85318341 7.86211442,8.04491933 7.78222445,8.25263323 C7.2469617,9.65869659 7.38277464,11.3523638 8.28553122,12.6545702 C8.47726713,12.9341851 8.70095903,13.189833 8.95660692,13.4135249 C10.2348463,14.5399734 12.0403595,14.6837753 13.4703899,13.7330847 L14.8684642,15.7383228 C14.9643322,15.8821248 15.1161231,15.9779927 15.275903,15.9939707 C15.435683,16.0179377 15.6034519,15.9700037 15.7312758,15.8581578 C15.8590998,15.7463118 15.9469787,15.5865319 15.9709457,15.402785 C15.9949127,15.235016 15.9469787,15.0592581 15.8511108,14.9154562 L15.8511108,14.9154562 Z M13.2866429,12.6625592 C12.2480734,13.5493378 10.8180431,13.5972718 9.72355056,12.7903832 C9.52382566,12.6465812 9.34007873,12.4708233 9.18828781,12.2870764 C9.12437584,12.2071864 9.06845286,12.1352855 9.01252989,12.0553955 C8.23759725,10.952914 8.18167427,9.49891667 8.764871,8.34850119 C8.96459591,7.94106238 9.23622178,7.59753553 9.57175964,7.31792066 C10.8100541,6.25538414 12.5836113,6.40717508 13.6541368,7.6774255 C13.8219057,7.86916141 13.9657076,8.08486431 14.0775536,8.3165452 C14.8205302,9.75456455 14.5169484,11.6239897 13.2866429,12.6625592 L13.2866429,12.6625592 Z M11.1376029,4.49780495 C12.4238313,4.49780495 13.6221808,4.92122177 14.6208053,5.63224244 C14.2692895,4.07438814 13.9417406,2.69229178 13.7659827,2.11708403 C13.3185989,0.599174719 12.4158423,0.0399449844 11.1376029,0.0399449844 L9.32410075,0.0399449844 L10.0191434,4.60965089 C10.3866373,4.52976092 10.7621201,4.49780494 11.1376029,4.49780495 L11.1376029,4.49780495 Z M8.87671695,3.83471825 L7.37478564,3.83471825 L7.25495069,6.55097702 C7.73429047,6.00772527 8.3094982,5.56034147 8.93263992,5.21681463 L8.87671695,3.83471825 Z M8.71693703,0.0559229688 L7.53456556,0.0559229688 L7.42271961,2.57245683 L8.82079398,2.57245683 L8.71693703,0.0559229688 Z M0.288545875,11.6559457 C0.112787953,12.2551204 0.01692,12.7823942 0.000942,13.237767 L0.000942,13.4694479 C0.0328979844,14.5239954 0.576149734,15.0992031 1.63868625,15.0992031 L4.40287898,15.0992031 L5.26569059,10.2099373 L0.680006688,10.2099373 C0.53620475,10.7771561 0.392402813,11.2804629 0.288545875,11.6559457 L0.288545875,11.6559457 Z M2.80507972,1.86942514 C2.66926678,2.29284195 2.48551986,2.99587363 2.27780597,3.82672925 L6.38415009,3.82672925 L7.04723678,0.0239669844 L4.61059289,0.0239669844 C3.63593533,0.111845938 3.33235347,0.191735906 2.80507972,1.86942514 Z M1.02353353,8.85180797 L5.4973715,8.85180797 L6.1364912,5.20083663 L1.93427912,5.20083663 C1.63069727,6.38320808 1.31912641,7.6774255 1.02353353,8.85180797 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-21.9%",
    y: "-15.6%",
    width: "143.8%",
    height: "143.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 11,
    transform: "translate(-705.000000, -613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(715.000000, 619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#05AA8A",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u9053\\u8DEF\\u5DE1\\u67E5",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlleys);
export default __webpack_public_path__ + "static/media/icon_alleys.5803192147583d14a96635a6e2790a63.svg";
export { ForwardRef as ReactComponent };